import * as React from 'react'
import { ModalC } from './ModalC'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ModalE = () => {
  return (
    <div className="ModalE exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ModalC />
      </Provider>
    </div>
  )
}
